import moment from "moment";

export default (dateRange, interval, intervalUnit = "minutes") => {
  if (isNaN(interval)) throw new Error("interval must be a valid number");
  if (interval <= 0) throw new Error("interval must be greater than 0");

  const startDate = dateRange.begin();
  const endDate = dateRange.end();

  const now = moment(startDate).clone();
  const dates = [];

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.toDate());
    now.add(interval, intervalUnit);
  }

  return dates;
};
